import * as Dialog from "@radix-ui/react-dialog";

import closeSvg from "../../img/close.svg";
import { Svg } from "../../utils/svgIcon";
import { Button } from "../Button";

import * as styles from "./DrawerHeader.css";

interface DrawerHeaderProps {
    title: string;
    onClose: () => void;
    closeAriaLabel?: string;
}

export function DrawerHeader({
    title,
    onClose,
    closeAriaLabel,
}: DrawerHeaderProps) {
    return (
        <div className={styles.container}>
            <div className={styles.titleRow}>
                <Dialog.Title className={styles.title}>{title}</Dialog.Title>
                <Button
                    variant="text"
                    size="icon"
                    onClick={onClose}
                    aria-label={closeAriaLabel}
                    className={styles.closeButton}
                    icon={<Svg src={closeSvg} />}
                />
            </div>
        </div>
    );
}
